import { createAegisTheme } from "./aegis.ts";

export { createAegisTheme };
export type { ColorMode } from "./tokens/colors.ts";

const theme = createAegisTheme("dark");
export default theme;
